import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Skill} from '../copilot.types';

const registry: Skill[] = [];

function registerSkill(skill: Skill): void {
  if (registry.find((skillInRegistry) => skillInRegistry.name === skill.name)) {
    console.error(`Skill "${skill.name}" is already registered`);
    throw Error(`Skill "${skill.name}" is already registered`);
  }

  registry.push(skill);
}

function getAllSkills(): Skill[] {
  return registry;
}

function getSkillsForBreadcrumbs(breadcrumbs: BreadcrumbName[]): Skill[] {
  const activeBreadcrumbs = new Set(breadcrumbs);

  function deepestMatchingBreadcrumbIndex(skill: Skill): number {
    return Math.max(
      ...skill.applicableBreadcrumbs
        .filter((bc) => activeBreadcrumbs.has(bc))
        .map((bc) => breadcrumbs.indexOf(bc)),
    );
  }

  return getAllSkills()
    .filter((skill) => skill.applicableBreadcrumbs.some((bc) => activeBreadcrumbs.has(bc)))
    .sort((a, b) => deepestMatchingBreadcrumbIndex(b) - deepestMatchingBreadcrumbIndex(a));
}

export {getAllSkills, getSkillsForBreadcrumbs, registerSkill};
